import { Button, Css, ModalBody, ModalFooter, ModalHeader, SubmitButton, useModal } from "@homebound/beam";
import { useFormState } from "@homebound/form-state";
import {
  BulkEditFields,
  bulkEditFormConfig,
  saveBulkEdit,
} from "src/routes/libraries/plan-package/takeoffs/components/BulkEditFields";
import {
  TakeoffsStoreState,
  useSelectedTliIds,
} from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerContext";
import { queryResult } from "src/utils";
import { StoreApi } from "zustand";
import { BulkEditFields_TliFragment } from "./BulkEditFields.generated";
import { useBulkEditModal_GetTlisQuery } from "./BulkEditModal.generated";

type BulkEditModalProps = { store: StoreApi<TakeoffsStoreState> };

export function BulkEditModal({ store }: BulkEditModalProps) {
  const { planPackage, itemTableApi } = store.getState();
  const selectedTliIds = useSelectedTliIds(itemTableApi);
  const tlisQuery = useBulkEditModal_GetTlisQuery({
    variables: { filter: { id: selectedTliIds, readyPlan: [planPackage.id] }, versionId: planPackage.version.id },
  });
  return queryResult(tlisQuery, ({ takeoffLineItemsPage }) => (
    <BulkEditModalView store={store} tlis={takeoffLineItemsPage.items} />
  ));
}

type BulkEditModalViewProps = { store: StoreApi<TakeoffsStoreState>; tlis: BulkEditFields_TliFragment[] };

function BulkEditModalView(props: BulkEditModalViewProps) {
  const { store, tlis } = props;
  const { saveTli } = store.getState();
  const { closeModal } = useModal();
  const formState = useFormState({ config: bulkEditFormConfig });

  return (
    <>
      <ModalHeader>
        <span css={Css.lg.$}>Bulk Edit</span>
      </ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.gap1.pb3.$}>
          <BulkEditFields store={store} formState={formState} tlis={tlis} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="quaternary" label="Cancel" onClick={closeModal} size="lg" />
        <SubmitButton
          label="Save"
          data-testid="saveBtn"
          form={formState}
          onClick={async () => {
            await saveBulkEdit({ formState, saveTli, tlis });
            closeModal();
          }}
          size="lg"
        />
      </ModalFooter>
    </>
  );
}
